'use client';

import { ToastContainer } from 'react-toastify';

/**
 * ToastContainer that only renders in non-production environments
 * - stepin.ai: Production (no toast)
 * - Other domains/localhost: Development/Staging (show toast)
 */
const ConditionalToastContainer = () => {
	// Check if current environment is production (stepin.ai domain)
	const isProduction = typeof window !== 'undefined' && window.location.hostname.includes('stepin.ai');

	// Don't render ToastContainer in production
	if (isProduction) {
		return null;
	}

	return <ToastContainer />;
};

export default ConditionalToastContainer;
